import {
  InteractionRequiredAuthError,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';

import { msalConfig } from '../authConfig';
import { environment } from '../config/environment';

export const authServiceSingleton = (function () {
  let msalInstance : IPublicClientApplication;
  const createInstance = async () => await PublicClientApplication.createPublicClientApplication(msalConfig);
  
  return {
    getMsalInstance : async () => {
      if (!msalInstance) {
        msalInstance = await createInstance();
      }
      return msalInstance;
    }
  };
})();

export const getAccessToken = async () => {
  const instance = await authServiceSingleton.getMsalInstance();
  const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0];
  if (!account) {
    throw new Error('User needs to be signed in before fetching access token');
  }

  // Request backend API scope
  const tokenRequest = {
    scopes: [
      'profile',
      environment.REACT_APP_SCOPE, // Backend API scope for user_impersonation
    ].filter(Boolean), // Filter out empty strings
    account,
  };

  try {
    const authResult = await instance.acquireTokenSilent(tokenRequest);
    return authResult.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      await instance.acquireTokenRedirect(tokenRequest);
      return null;
    }
    // Cache is likely stale/corrupted — clear it and force re-authentication
    console.warn('Silent token acquisition failed, clearing cache and redirecting:', error);
    await instance.clearCache();
    await instance.acquireTokenRedirect(tokenRequest);
    return null;
  }
} 
